module.exports = __webpack_public_path__ + "static/img/TVE-Selected.133590f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/dataSources/TVE-Selected.png
// module id = 1580
// module chunks = 0